const reasons: { [key: string]: string } = {
  QUANTITY_LIMIT_EXCEEDED: 'Лимит в позиции исчерпан',
  INCORRECT_RECEIPT_ITEMS: 'Неверные позиции в чеке',
  INCORRECT_RECEIPT: 'Некорректный чек',
  DEVIATION_PERCENT_INCORRECT: 'Процент отклонения меньше фактической',
  RECEIPT_NOT_FOUND_IN_TAX: 'Чек не найден в ФНС',
  INTERNAL_ERROR: 'Неожиданная внутренняя ошибка',
};

export const saleFailureReason = (sale: {
  saleStatus?: string;
  failStatusReason?: string | null;
}): string => {
  if (sale.saleStatus !== 'FAIL') return '';
  const reason = (sale.failStatusReason || '').trim();
  return reasons[reason] || reason || 'Причина отказа не сохранена';
};
